import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { isCancel } from 'axios'

// Sentry
if (process.env.VUE_APP_SENTRY_ENABLED === 'true') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENV,
    beforeSend(event, hint) {
      /**
       * There is no need for the cancel requests to be sent to Sentry.
       * The expected originalException is "cancel request"
       */
      if (isCancel(hint?.originalException)) {
        return null
      }

      // Check if it is an exception, and if so, show the report dialog
      if (event.exception && event.event_id) {
        // Sentry.showReportDialog({ eventId: event.event_id })
      }

      return event
    },

    // integrations: [
    //   new Sentry.BrowserTracing({
    //     // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    //     tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //   }),
    //   new Sentry.Replay(),
    // ],
    // // Performance Monitoring
    // tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}
